import { ILoginFormLang } from '../../../types/lang'

export const loginFormLang: ILoginFormLang = {
	login_form: {
		field_user_name_label: 'User Name',
		field_user_name_placeholder: 'User Name',
		field_password_label: 'Password',
		field_password_placeholder: 'Password',
		msg_login_success: 'Welcome back, {{name}}!',
		btn_login: 'Login',
	}
}